import type {DataNodes, MeshNodes} from "@cm/render-nodes"

export function getMeshGraphInfo(graph: MeshNodes.Mesh) {
    const dataObjectReferences: DataNodes.DataObjectReference[] = []
    let maxSubdivLevel = 0
    const visited = new Set<unknown>()
    const traverseMeshData = (node: MeshNodes.Mesh) => {
        if (visited.has(node)) return
        visited.add(node)
        if (node.type === "geomGraph") {
            traverseGeomExpr(node.graph)
        } else if (node.type === "loadMesh") {
            if (node.data.type === "dataObjectReference") {
                dataObjectReferences.push(node.data)
            }
        } else if (node.type === "subdivide") {
            maxSubdivLevel = Math.max(maxSubdivLevel, node.levels)
            traverseMeshData(node.input)
        }
    }
    const traverseGeomExpr = (node: MeshNodes.GeometryExpr | MeshNodes.GeometryExprArg | MeshNodes.GeometryExprArg[]) => {
        if (visited.has(node)) return
        visited.add(node)
        if (Array.isArray(node)) {
            for (const subNode of node) {
                traverseGeomExpr(subNode)
            }
        } else if (typeof node === "object") {
            if (node.op === "meshToGeom") {
                traverseMeshData((node as MeshNodes.MeshToGeometry).args[0])
            } else {
                for (const arg of (node as MeshNodes.GeometryOperator).args) {
                    if (typeof arg === "object") {
                        traverseGeomExpr(arg)
                    }
                }
            }
        }
    }
    traverseMeshData(graph)
    return {
        dataObjectReferences,
        maxSubdivLevel,
    }
}
